import React, { useState } from 'react';
import UserProfileToggle from './user_profile_toggle';

export default function VcardToggle({ showVcard }: VcardToggleProps) {
  const [shouldShowVcard, setShouldShowVcard] = useState(showVcard);

  return (
    <UserProfileToggle
      checked={shouldShowVcard}
      label="Show vcard on Broker Plugin"
      name="user[show_vcard_on_broker_plugin]"
      onChange={() => setShouldShowVcard(!shouldShowVcard)}
    />
  );
}

type VcardToggleProps = {
  showVcard: boolean;
};
